require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./a-vr-native-360-ios-swift-master.json") })
        }
      }, "path---a-vr-native-360-ios-swift-master");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---a-vr-native-360-ios-swift-master!./.cache/json/a-vr-native-360-ios-swift-master.json
// module id = 494
// module chunks = 231608221292675